import { StyleType } from '../../doodle/view/StyleType'

export const SubmitButton = ({ label, disabled, style }: { label: string; disabled?: boolean; style?: StyleType }) => (
  <button data-text={label} class="mui-btn mui-btn--small mui-btn--raised mui-btn--primary" disabled={disabled} style={style}>
    {label}
  </button>
)
